/* Lisen – brandlogoerne ruller stille hen over skærmen på mobil (Claude, sep. 2026)
   Hører sammen med assets/lisen-brands.css.

   Rækken er et almindeligt vandret scroll-felt, så man kan swipe i den.
   Scriptet skubber den nogle få pixels i sekundet og kører i ring ved at
   klone logoerne én gang. Rører kunden rækken, holder den pause i 4
   sekunder. På computer og ved "reducér bevægelse" sker der ingenting. */
(function () {
  if (window.LisenBrands) return;
  window.LisenBrands = true;

  var MOBIL = 768;
  var FART = 0.35; // pixels pr. billede (ca. 20 px i sekundet)
  var PAUSE = 4000;

  function opsaet(baand) {
    if (baand.getAttribute('data-lisen-brands')) return;
    baand.setAttribute('data-lisen-brands', '');

    var originaler = Array.prototype.slice.call(baand.children);
    if (originaler.length < 2) return;

    var klonet = false;
    var pauseTil = 0;

    ['touchstart', 'pointerdown', 'wheel'].forEach(function (navn) {
      baand.addEventListener(navn, function () { pauseTil = Date.now() + PAUSE; }, { passive: true });
    });

    // Billederne hentes dovent, så vi venter med at klone, til de har en kilde
    function billederKlar() {
      return originaler.every(function (n) {
        var im = n.querySelector('img');
        return !im || im.currentSrc || im.getAttribute('src');
      });
    }

    function klon() {
      if (klonet || !billederKlar()) return;
      originaler.forEach(function (n) {
        var k = n.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('data-lisen-klon', '');
        var orgImg = n.querySelector('img');
        var klonImg = k.querySelector('img');
        if (orgImg && klonImg) {
          var kilde = orgImg.currentSrc || orgImg.getAttribute('src');
          if (kilde) {
            klonImg.setAttribute('src', kilde);
            if (orgImg.getAttribute('srcset')) klonImg.setAttribute('srcset', orgImg.getAttribute('srcset'));
            if (orgImg.getAttribute('sizes')) klonImg.setAttribute('sizes', orgImg.getAttribute('sizes'));
            klonImg.className = klonImg.className.replace(/lazyload\b/, '').trim();
          }
        }
        baand.appendChild(k);
      });
      klonet = true;
    }

    function synlig() {
      var r = baand.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || 0);
    }

    function skridt() {
      var kanRulle = window.innerWidth <= MOBIL && baand.scrollWidth > baand.clientWidth + 4;
      if (kanRulle && synlig()) {
        klon();
        if (klonet && Date.now() > pauseTil) {
          var halv = baand.scrollWidth / 2;
          baand.scrollLeft += FART;
          if (baand.scrollLeft >= halv) baand.scrollLeft -= halv;
        }
      }
      window.requestAnimationFrame(skridt);
    }

    window.requestAnimationFrame(skridt);
  }

  function start() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var baand = document.querySelectorAll('.custom-content__brands, .logo-bar');
    for (var i = 0; i < baand.length; i++) opsaet(baand[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
